import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { NewPaymentScreen } from "../screens/PaymentsScreen";
import { newPaymentSearch } from "../screens/purchaseSearch";

export const Route = createFileRoute("/prototype/c/$companyId/purchases/payments/new")({
  validateSearch: (search) => newPaymentSearch.parse(search),
  component: NewPayment,
});

function NewPayment() {
  const { companyId } = Route.useParams();
  const { supplier, credit } = Route.useSearch();
  return (
    <NewPaymentScreen
      companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY}
      supplier={supplier}
      credit={credit}
    />
  );
}
